import { Text } from '@zillow/constellation-10';

export const SmallDropzone = () => <Text css={{ marginTop: '200' }}>Add</Text>;
